export default __webpack_public_path__ + "static/media/undo.2a698220.png";